import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';

const Main = ({ default_value, value, show_message, onChange }) => {
  const [input_value, setInputValue] = useState(value?.value)

  useEffect(() => {
    if(default_value !== undefined) {
      doSetValue(default_value)
    }
  }, [])

  const doSetValue = (newValue) => {
    setInputValue(newValue)

    if(onChange) {
      onChange({...value, value: newValue})
    }
  }

  return (
    <>
      <TextField
        value={value?.value}
        label="Invoice Number"
        onChange={(e) => doSetValue(e.target.value)}
        fullWidth
      />
      {show_message && <p>{value?.message}</p>}
    </>
  )
}

export default Main;
